import { Outlet } from "react-router-dom";

export { default as Search } from "./Search";
export { default as ItemnumberView } from "./ItemnumberView";

const Index = () => (
  <div className="card">
    <div className="card-body pt-1">
      <Outlet />
    </div>
  </div>
);

export default Index;
